import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress
} from "@material-ui/core";

interface ResetDocumentStatusDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void> | void;
}

const ResetDocumentStatusDialog: React.FC<ResetDocumentStatusDialogProps> = ({
  open,
  onClose,
  onConfirm
}) => {

  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      aria-labelledby="reset-status-dialog-title"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="reset-status-dialog-title">
        Reiniciar estado del comprobante
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          ¿Está seguro que desea <strong>reiniciar el estado del comprobante</strong>?
        </DialogContentText>

        <DialogContentText style={{ marginTop: 8 }}>
          Esta acción devolverá el comprobante a su estado inicial y
          <strong> no podrá deshacerse.</strong>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          color="default"
          variant="outlined"
          disabled={loading}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleConfirm}
          color="secondary"
          variant="contained"
          disabled={loading}
          startIcon={
            loading ? <CircularProgress size={18} color="inherit" /> : null
          }
        >
          {loading ? "Procesando..." : "Reiniciar estado"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResetDocumentStatusDialog;